import React from 'react';

import { db, auth } from '../functions/firebaseFunctions'
export default function Price(props) {
    const { type, color, style, price, item, F, navigation, event } = props
    // console.log( type, color, style, price, item, F, navigation, event )

    let col = "var(--wht)"
    let obj
    if (type && type == "pay" && item && F) {
        if (F == "Service") {
            const { artistId, duration, name, type, uid, statusPath, bkVenueDocId, eventId } = item
            obj = {
                to: { id: artistId, name: name },
                // from:uid,
                from: {
                    id: uid,
                    name: auth.currentUser?.displayName ? auth.currentUser?.displayName : ''
                },
                qty: duration,
                F: F,
                for: F + " - " + type,
                price: price,
                event: event,
                statusPath: statusPath,
                bkVenueDocId: bkVenueDocId,
                eventId: eventId
            }
        } else if (F == "Venue") {
            let name = 'Owner'
            const { ownerId, venueName, uid, address, statusPath, bkVenueDocId, eventId } = item
            db.collection('users').doc(ownerId).get().then(res => {
                if (res.exists) {

                    name = res.data().name
                }
            }).then((r) => {
                obj = {
                    to: { id: ownerId, name: name },
                    // from:uid,
                    from: {
                        id: uid,
                        name: auth.currentUser?.displayName ? auth.currentUser?.displayName : ''
                    },
                    qty: 1,
                    F: F,
                    for: F + " - " + venueName,
                    price: price,
                    event: event,
                    address: address,
                    statusPath: statusPath,
                    bkVenueDocId: bkVenueDocId,
                    eventId: eventId
                }
            }).catch(e => console.log(e))

        }
    }
    if (color) { col = color }
    return (
        <React.Fragment>
            <div >
                {type && type == "pay" ? <div style={{display: 'flex', flexDirection: 'row'}}
                    onClick={() => { console.log('Pay', { payi: obj }) }}>
                    <p style={{ color: "var(--org)", fontWeight: 'bold', fontSize: 18, marginInline: 5 }}>${price}</p>
                    <p style={{ color: "var(--wht)", fontSize: 12, textAlign: 'center',  }}>Pay</p>
                </div>
                    :
                    <div style={props.style != 'inline' ? {
                        alignItems: 'flex-end'
                    } : { flexDirection: 'row' }}>
                        <p style={{ color: "var(--org)", fontWeight: 'bold', fontSize: 18 }}>${price}</p>
                        {type && <p style={{ color: "var(--ltg)", fontSize: 12 }}>per {type == "day" ? "day" : "hour"}</p>}
                    </div>}
                </div>
        </React.Fragment>


    )
}